import React from "react";
import { Box, Typography } from "@mui/material";

const StudentHeader = ({ student }) => {
  const lastActive =
    student.lastActive && student.lastActive !== "—"
      ? student.lastActive
      : "—";

  return (
    <Box>
      <Typography variant="h4" fontWeight={600}>
        {student.name}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {student.email} • Last Active {lastActive}
      </Typography>
    </Box>
  );
};

export default StudentHeader;
